"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_decorators_1 = require("lodash-decorators");
exports.default = lodash_decorators_1.debounce;
